import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'
import { ProcurementContractRouter } from './contract/_router'

const Index = lazy(() => import('./Index'))
const Dashboard = lazy(() => import('./Dashboard'))

export const ProcurementRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--procurement']}>
    <Route index element={<Index />} />
    <Route path='dashboard' element={<Dashboard />} />
    <Route path='contract/*' element={<ProcurementContractRouter />} />
  </SubRouter>
))
